import {
  fetchPostById,
  fetchPosts,
  fetchRecentPostPreviews,
} from "@/lib/wordpress/utils";

import InfoPage from "@/components/InfoPage";

export const BLOG_PREVIEW_POST_ID = "cG9zdDozMA==";

export default async function AboutUs() {
  const [posts, blogPost, recentPosts] = await Promise.all([
    fetchPosts(),
    fetchPostById(BLOG_PREVIEW_POST_ID),
    fetchRecentPostPreviews(),
  ]);

  const blogExcerpt =
    recentPosts.find((p) => p.node.id === BLOG_PREVIEW_POST_ID)?.node.excerpt ??
    null;

  return (
    <div id="homepage_Holder">
      <InfoPage posts={posts} blogPost={blogPost} blogExcerpt={blogExcerpt} />
    </div>
  );
}
